/**
 * Desktop CSS grid template for comparable-company rows/headers.
 * Column count follows access: Full (EBIT + margin) > Lite details (CAGR) > basic.
 *
 * @param {boolean} hasExtendedAccess Full / extended financials
 * @param {boolean} hasDetailsAccess Lite+ details (CAGR 3Y)
 * @returns {string} grid-template-columns value
 */
export const getComparableCompaniesGridTemplateColumns = (
  hasExtendedAccess,
  hasDetailsAccess
) => {
  if (hasExtendedAccess) {
    return 'repeat(3, 2fr) repeat(5, 1fr) 100px';
  }
  if (hasDetailsAccess) {
    return 'repeat(3, 2fr) repeat(3, 1fr) 100px';
  }
  return 'repeat(3, 2fr) repeat(2, 1fr) 100px';
};
